import { Singleton } from 'typescript-ioc'
import { IHydratedPageAnalysisConfig } from '@halo/interfaces/hydrated-page-analysis-config'
import aqe from '@pushly/aqe'
import { IApiResponse, IPageAnalysis } from '@pushly/aqe/lib/interfaces'
import ICategoryStrategy from '@halo/interfaces/category-strategy'
import querystring from 'query-string'
import { axiosFetch, isAxiosResponseError } from '@halo/_utils/axios'

@Singleton
export class PageAnalysisService {
    public async analyze(
        pageUrl: string,
        domainId?: number,
        pageAnalysisConfigId?: number,
        hydratedPageAnalysisConfig?: Partial<IHydratedPageAnalysisConfig>,
        categoryStrategies?: Array<Partial<ICategoryStrategy>>,
    ): Promise<IApiResponse<IPageAnalysis>> {
        const qp = querystring.stringify({
            pageUrl,
            domainId,
            pageAnalysisConfigId,
        })

        const url = `${aqe.defaults.publicApiDomain}/v3/page-analysis/run?${qp}`
        try {
            const req = await axiosFetch('post', {
                url,
                data: {
                    hydratedPageAnalysisConfig,
                    categoryStrategies,
                },
            })

            const reqData = req.data.data
            if ('error_message' in reqData) {
                return {
                    ok: false,
                    data: null,
                    error: new Error(`${reqData.error_type} ${reqData.error_message}`),
                }
            } else {
                return {
                    ok: true,
                    data: reqData,
                }
            }
        } catch (error) {
            if (isAxiosResponseError(error)) {
                throw error
            }
        }
    }
}
